var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('div',{staticClass:"logo__img-bx"},[_c('img',{staticClass:"logo__img",attrs:{"src":require("@/assets/common/logo-light-sm.png"),"alt":"logo"}})]),_c('div',{staticClass:"logo__title"},[_vm._v("YAFI KAMINER")])])
}]

export { render, staticRenderFns }